<template>
  <v-card class="pa-4 mt-4 painel-escala">
    <div class="d-flex flex-wrap align-center justify-space-between mb-2">
      <div class="text-subtitle-1 font-weight-bold text-dark">
        {{ $t("roteiro_escala_titulo") }}
      </div>

      <div class="d-flex align-center">
        <v-btn
          small
          outlined
          class="
            ma-1
            font-weight-bold
            text-none
            btn-primary
            bg-gradient-primary
            py-3
            px-6
            ms-3
          "
          height="39"
          :loading="loadingEscala"
          @click="carregarEscala"
        >
          {{ $t("Atualizar") }}
        </v-btn>
        <v-btn
          small
          class="
            ma-1
            font-weight-bold
            text-none
            btn-primary
            bg-gradient-primary
            py-3
            px-6
            ms-3
          "
          height="39"
          :loading="gerandoEscala"
          @click="gerarEscalaAutomatica"
        >
          {{ $t("roteiro_escala_gerar_automatica") }}
        </v-btn>
      </div>
    </div>

    <div class="text-caption grey--text text--darken-1 mb-4">
      {{ regrasEscalaTexto }}
    </div>

    <v-row dense>
      <v-col cols="12" md="3">
        <v-select
          v-model="novoItem.tipo"
          :items="tiposFuncaoPermitidos"
          item-text="text"
          item-value="value"
          :label="$t('roteiro_escala_funcao')"
          dense
          outlined
          hide-details
          @change="carregarFuncionarios"
        />
      </v-col>

      <v-col cols="12" md="7">
        <v-autocomplete
          v-model="novoItem.funcionarioId"
          :items="funcionariosDisponiveis"
          :loading="loadingFuncionarios"
          item-text="texto"
          item-value="id"
          :label="$t('roteiro_escala_funcionario')"
          dense
          outlined
          hide-details
        />
      </v-col>

      <v-col cols="12" md="2">
        <v-btn
          block
          class="
            ma-1
            font-weight-bold
            text-none
            btn-primary
            bg-gradient-primary
            py-3
            px-6
            ms-3
          "
          height="39"
          :loading="salvandoItem"
          @click="adicionarItem"
        >
          {{ $t("Adicionar") }}
        </v-btn>
      </v-col>
    </v-row>

    <div
      v-if="!escala.length && !loadingEscala"
      class="mt-4 text-caption grey--text"
    >
      {{ $t("roteiro_escala_vazio") }}
    </div>

    <v-simple-table v-else class="mt-4">
      <thead>
        <tr>
          <th>{{ $t("roteiro_escala_funcao") }}</th>
          <th>{{ $t("Matricula") }}</th>
          <th>{{ $t("Nome") }}</th>
          <th class="text-right">{{ $t("Acoes") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in escala" :key="item.id">
          <td>
            <v-chip
              x-small
              :color="corFuncao(item.funcao || item.tipo)"
              text-color="white"
            >
              {{ formatarFuncao(item.funcao || item.tipo) }}
            </v-chip>
          </td>
          <td>{{ item.matricula || "-" }}</td>
          <td>{{ item.nomeSocial || item.nomePessoa || "-" }}</td>
          <td class="text-right">
            <v-btn
              icon
              small
              color="error"
              :loading="removendoId === item.id"
              @click="removerItem(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
import DataService from "@/services/operacoes/RoteiroDataService";

export default {
  name: "PainelEscalaRoteiro",
  props: {
    roteiro: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      escala: [],
      loadingEscala: false,
      loadingFuncionarios: false,
      gerandoEscala: false,
      salvandoItem: false,
      removendoId: null,
      novoItem: {
        tipo: "MOTORISTA",
        funcionarioId: null,
      },
      funcionariosDisponiveis: [],
    };
  },
  computed: {
    tiposFuncao() {
      return [
        {
          text: this.$t("roteiro_escala_tipo_chefe_equipe"),
          value: "CHEFE_EQUIPE",
        },
        {
          text: this.$t("roteiro_escala_tipo_motorista"),
          value: "MOTORISTA",
        },
        {
          text: this.$t("roteiro_escala_tipo_escolta"),
          value: "ESCOLTA",
        },
      ];
    },
    tiposFuncaoPermitidos() {
      if (this.roteiro?.tipoRoteiro === "LEVE") {
        return this.tiposFuncao.filter((item) => item.value !== "ESCOLTA");
      }
      return this.tiposFuncao;
    },
    regrasEscalaTexto() {
      const tipo = this.roteiro?.tipoRoteiro || "OUTROS";
      if (tipo === "FORTE") {
        return this.$t("roteiro_escala_regra_forte");
      }
      if (tipo === "LEVE") {
        return this.$t("roteiro_escala_regra_leve");
      }
      return this.$t("roteiro_escala_regra_outros");
    },
  },
  watch: {
    "roteiro.id": {
      immediate: true,
      handler() {
        this.inicializarPainel();
      },
    },
    "roteiro.tipoRoteiro": {
      handler() {
        if (
          this.roteiro?.tipoRoteiro === "LEVE" &&
          this.novoItem.tipo === "ESCOLTA"
        ) {
          this.novoItem.tipo = "MOTORISTA";
        }
        this.carregarFuncionarios();
      },
    },
  },
  methods: {
    formatarFuncao(funcao) {
      const valor = String(funcao || "").toUpperCase();
      if (valor.includes("CHEFE")) {
        return this.$t("roteiro_escala_tipo_chefe_equipe");
      }
      if (valor.includes("MOTORISTA")) {
        return this.$t("roteiro_escala_tipo_motorista");
      }
      if (valor.includes("ESCOLTA")) {
        return this.$t("roteiro_escala_tipo_escolta");
      }
      return funcao || "-";
    },
    corFuncao(funcao) {
      const valor = String(funcao || "").toUpperCase();
      if (valor.includes("CHEFE")) {
        return "green darken-2";
      }
      if (valor.includes("MOTORISTA")) {
        return "blue darken-2";
      }
      if (valor.includes("ESCOLTA")) {
        return "orange darken-2";
      }
      return "primary";
    },
    inicializarPainel() {
      if (!this.roteiro?.id) {
        this.escala = [];
        this.funcionariosDisponiveis = [];
        return;
      }
      this.carregarEscala();
      this.carregarFuncionarios();
    },
    carregarEscala() {
      if (!this.roteiro?.id) {
        return;
      }
      this.loadingEscala = true;
      DataService.getEscala(this.roteiro.id)
        .then((res) => {
          this.escala = Array.isArray(res.data) ? res.data : [];
          this.$emit("escalaChanged", this.escala);
        })
        .catch((error) => {
          console.error(error);
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("roteiro_escala_erro_carregar"),
            "error"
          );
        })
        .finally(() => {
          this.loadingEscala = false;
        });
    },
    carregarFuncionarios() {
      if (!this.novoItem.tipo) {
        this.funcionariosDisponiveis = [];
        return;
      }
      this.loadingFuncionarios = true;
      DataService.getFuncionariosEscala(this.novoItem.tipo)
        .then((res) => {
          const lista = Array.isArray(res.data) ? res.data : [];
          this.funcionariosDisponiveis = lista.map((item) => ({
            ...item,
            texto: `${item.matricula || "-"} - ${item.nomeSocial || "-"}`,
          }));
        })
        .catch((error) => {
          console.error(error);
          this.funcionariosDisponiveis = [];
        })
        .finally(() => {
          this.loadingFuncionarios = false;
        });
    },
    adicionarItem() {
      if (!this.roteiro?.id) {
        return;
      }
      if (!this.novoItem.funcionarioId) {
        this.$swal.fire(
          this.$t("Atencao"),
          this.$t("roteiro_escala_alert_selecione_funcionario"),
          "warning"
        );
        return;
      }
      this.salvandoItem = true;
      DataService.addEscala(this.roteiro.id, this.novoItem)
        .then(() => {
          this.novoItem.funcionarioId = null;
          this.carregarEscala();
        })
        .catch((error) => {
          console.error(error);
          const mensagem =
            error?.response?.data?.message ||
            this.$t("roteiro_escala_erro_adicionar");
          this.$swal.fire(this.$t("Erro"), mensagem, "error");
        })
        .finally(() => {
          this.salvandoItem = false;
        });
    },
    removerItem(item) {
      if (!this.roteiro?.id || !item?.id) {
        return;
      }
      this.removendoId = item.id;
      DataService.removeEscala(this.roteiro.id, item.id)
        .then(() => {
          this.carregarEscala();
        })
        .catch((error) => {
          console.error(error);
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("roteiro_escala_erro_remover"),
            "error"
          );
        })
        .finally(() => {
          this.removendoId = null;
        });
    },
    gerarEscalaAutomatica() {
      if (!this.roteiro?.id) {
        return;
      }
      this.gerandoEscala = true;
      DataService.gerarEscalaAutomatica(this.roteiro.id)
        .then((res) => {
          this.escala = Array.isArray(res.data) ? res.data : [];
          this.$emit("escalaChanged", this.escala);
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("roteiro_escala_sucesso_gerada"),
            "success"
          );
        })
        .catch((error) => {
          console.error(error);
          const mensagem =
            error?.response?.data?.message ||
            this.$t("roteiro_escala_erro_gerar");
          this.$swal.fire(this.$t("Erro"), mensagem, "error");
        })
        .finally(() => {
          this.gerandoEscala = false;
        });
    },
  },
};
</script>

<style scoped>
.painel-escala {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}
</style>
